var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('user-data-update-form',{attrs:{"user-name":_vm.user.name,"loading":_vm.loading},on:{"onSave":_vm.handleContactInfoUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }